import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AuthConnectionGuard  {
  constructor(private router : Router) {}
  
  async canActivate() {
    if(environment.connId === '9' || environment.connId === '1009') {
      return true;
    }

    this.router.navigate(["/"]);
    return false;
  }
}
